export const ALLOCATION_CHART_SETTINGS = 'allocation_chart_settings';
